const Layout = ({ children }: any) => {
    return <section className="px-5 md:px-20 lg:px-64">{children}</section>;
};

export default Layout;
